import { render, staticRenderFns } from "./create-year-folder.vue?vue&type=template&id=900843ba"
import script from "./create-year-folder.vue?vue&type=script&lang=js"
export * from "./create-year-folder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports